import { render, staticRenderFns } from "./linkPlayer.vue?vue&type=template&id=4a3a425e"
import script from "./linkPlayer.vue?vue&type=script&lang=js"
export * from "./linkPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports